import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { checkValueIncluded } from 'models/validate';
import { OTHER } from 'constants/values';
import pvqInvestigatingAgency from 'forms/shared/validators/models/pvqInvestigatingAgency/pvqInvestigatingAgency';
import { LegalInvestigationsDebarredItemModel } from '../types';

export const legalInvestigationsDebarredItemValidator: ValidateJSModel<LegalInvestigationsDebarredItemModel> = {
  Agency: (value, attributes, attributeName, options) => {
    if (attributes?.AgencyNotApplicable?.applicable === false) {
      return {};
    }

    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqInvestigatingAgency } };
    }

    return { presence: true, hasValue: true };
  },
  AgencyExplanation: (value, attributes, attributeName, options = {}) => {
    if (isPVQForm(options?.formType) && checkValueIncluded(attributes?.Agency, [OTHER])) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  AgencyNotApplicable: {},
  Date: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    const { applicantBirthdate } = options;

    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },
  DateRange: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
      };
    }

    return {};
  },
  Explanation: { presence: true, hasValue: true },
};
